module.exports = __webpack_public_path__ + "img/oneGraypng.ef671c49.png";